<textarea
    [formControl]="control"
    [id]="id"
    class="sh-input-field sh-form-group__input"
    [attr.autocomplete]="autocomplete || null"
    [attr.placeholder]="message$ | async"
    [attr.aria-describedBy]="invalid ? describeLabelId : null"
    [attr.aria-invalid]="invalid"
    [attr.resizable]="resizable || false"
    [attr.rows]="rows"
    [attr.disabled]="disabled ? true : null"
    [ngClass]="{'-sh-non-resizable' : !resizable}"
></textarea>
